import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	onboardingHeading: {
		id: 'jira-issue-table-hide-done-toggle.onboarding.onboarding-heading',
		defaultMessage: 'Hide done work items',
		description: 'Onboarding title for the hide done feature',
	},
	onboardingDescription: {
		id: 'jira-issue-table-hide-done-toggle.onboarding.onboarding-description',
		defaultMessage: "Quickly hide work that's done without adding a filter.",
		description: 'Onboarding message for the hide done feature',
	},
	ok: {
		id: 'jira-issue-table-hide-done-toggle.onboarding.done',
		defaultMessage: 'OK',
		description: 'Cta label to finalize the onboarding',
	},
});
